/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Sync_OkInputs */

const cs_builder_sync_ok = /** @type {(inputs: Builder_Sync_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchronizováno`)
};

const en_builder_sync_ok = /** @type {(inputs: Builder_Sync_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synced`)
};

/**
* | output |
* | --- |
* | "Synced" |
*
* @param {Builder_Sync_OkInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_sync_ok = /** @type {((inputs?: Builder_Sync_OkInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Sync_OkInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_sync_ok(inputs)
	return cs_builder_sync_ok(inputs)
});